import React, { useState, useContext, useEffect } from "react";
import { Row, Button, ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap';
import useWindowDimensions from "../WindowDimensions";

import { LocalizationContext } from "./LocalizationContext";
import { EventContext, INIT_STATUS_COMPLETED } from "./App";
import { AdminUserInformationContext, C4FStatusContext, SitterUserInformationContext, UserInformationContext, ReferenceDataContext } from "./App";
import { getUnicodeOrImageFlagForLanguage } from "../common/Helpers";


function Navigation(props) {
  const { getLocalizedText } = useContext(LocalizationContext);
  const { initialized, action, handleAction, language, setLanguage, browserInfo } = useContext(C4FStatusContext);
  const { countries } = useContext(ReferenceDataContext);
  const { events } = useContext(EventContext);
  const { userInformation, sessionInformation } = useContext(UserInformationContext);
  const { adminUserInformation } = useContext(AdminUserInformationContext);
  const { sitterUserInformation } = useContext(SitterUserInformationContext);
  const { width } = useWindowDimensions();

  const [navigationType, setNavigationType] = useState('s');

  function showButton(action) {
    // not shown when sitter is active
    if (sitterUserInformation !== null &&
      ['nc', 'team', 'finance', 'transfermarket', 'training', 'admin',
        'profile', 'fairplay', 'nationsCommittee', 'raceEditor', 'inscription'].includes(action))
      return false;
    // only shown when logged in
    if (userInformation === null &&
      ['home', 'nc', 'team', 'finance', 'transfermarket', 'training', 'admin', 'calendar', 'statistics',
        'profile', 'fairplay', 'nationsCommittee', 'raceEditor', 'chat', 'race', 'inscription', 'logout', 'messages', 'messagesUnread'].includes(action))
      return false;
    // only shown when logged off
    if (['login', 'signup', 'start'].includes(action)) {
      if (userInformation !== null) return false;
    }
    // only shown for admins
    if (action === 'admin') {
      if (adminUserInformation !== null || !userInformation.roles.includes('Admin')) return false;
    }
    // only shown when use is entered
    if (action === 'exitAdmin') {
      if (adminUserInformation === null) return false;
    }
    // only shown when sitting
    if (action === 'exitSitter') {
      if (sitterUserInformation === null) return false;
    }
    // only shown for admins, FPC members and [users with open or archived fairplay involvement]
    if (action === 'fairplay') {
      if (userInformation === null) return false;
      if (sitterUserInformation !== null) return false;
      // users get the possility to view archived fairplay cases
      if (userInformation.fairplayCases.length > 0) return true;
      if (userInformation.roles.includes('FairplayCommittee') || userInformation.roles.includes('Admin')) return true;
      return false;
    }
    // only shown during national championships
    if (action === 'nc') {
      if (events === null || !events.some(e => e.eventType === 'NationalChampionships')) return false;
    }
    // only shown for nations committee members
    if (action === 'nationsCommittee') {
      if (userInformation.roles.includes('NationsCommittee') || userInformation.roles.includes('Admin')) return true;
      return false;
    }
    // only shown when logged in and messages are available
    if (action === 'messages') {
      if ('notifications' in userInformation && userInformation.notifications.some(n => n.status === 'Unread'))
        return false;
    }
    if (action === 'messagesUnread') {      
      if (!('notifications' in userInformation) || !userInformation.notifications.some(m => m.status === 'Unread'))
        return false;
    }
    if (action === 'sandbox') {     
      // if (!config.DEV_MODE || !config.REST_API.match('localhost'))
        return false;
    }
    return true;
  }

  function getButtonVariant(newAction) {
    let prefix = action === newAction ? '' : 'outline-';
    switch (newAction) {
      case 'login': return 'primary';
      // case 'logout': return 'danger';
      case 'signup': return 'success';
      default: return prefix + 'secondary';
    }
  }

  function handleNavigationType() {
    switch (navigationType) {
      case 's': setNavigationType('m'); return;
      case 'm': setNavigationType('l'); return;
      default: setNavigationType('s'); return;
    }
  }

  useEffect(() => {
    if (width < 1000) setNavigationType('s');
    else setNavigationType('l');
  }, [width]);

  return initialized === INIT_STATUS_COMPLETED ? (
    <>
      <Row style={{ backgroundColor: 'rgba(240, 240, 240, 1)' }}>
        <ButtonGroup key={'navigation' + navigationType} className="m-1">
          <Button size="sm" variant={'outline-secondary'} onClick={() => handleNavigationType()}>{'\u2630'}</Button>
          {navigationType === 'l' ?
            <>
              {['start', 'home', 'team', 'inscription', 'race', 'nc', 'transfermarket',
                'training', 'finance', 'calendar', 'statistics',
                'chat', 'manual', 'exitAdmin', 'exitSitter', 'signup', 'login'].map(newAction =>
                  showButton(newAction) ?
                    <Button size="sm" variant={getButtonVariant(newAction)} onClick={() => handleAction(newAction)}>{getLocalizedText('navigation', newAction)}</Button>
                    : null)
              }
              <DropdownButton as={ButtonGroup} size="sm" title={getLocalizedText('navigation', 'more')}
                variant={'outline-secondary'} onSelect={(action, e) => handleAction(action)}>
                {['forum', 'fairplay', 'nationsCommittee', 'raceEditor', 'admin', 'profile', 'messages', 'messagesUnread', 'logout'].map(action =>
                  showButton(action) ?
                    <Dropdown.Item key={action} eventKey={action}>{getLocalizedText('navigation', action)}</Dropdown.Item>
                    : null
                )
                }
              </DropdownButton>

            </>
            : null}
          {navigationType === 'm' ?
            <>
              <DropdownButton as={ButtonGroup} size="sm" title={getLocalizedText('navigation', 'home')}
                variant={'secondary'} onSelect={(action, e) => handleAction(action)}>
                {['start', 'home', 'profile',
                  'admin', 'messages', 'messagesUnread', 'exitAdmin', 'exitSitter', 'signup', 'login', 'logout'].map(action =>
                    showButton(action) ?
                      <Dropdown.Item key={action} eventKey={action}>{getLocalizedText('navigation', action)}</Dropdown.Item>
                      : null
                  )
                }
              </DropdownButton>
              {userInformation !== null ?
                <DropdownButton as={ButtonGroup} size="sm" title={'Team'}
                  variant={'outline-secondary'} onSelect={(action, e) => handleAction(action)}>
                  {['team', 'transfermarket', 'training', 'finance'].map(action =>
                    showButton(action) ?
                      <Dropdown.Item key={action} eventKey={action}>{getLocalizedText('navigation', action)}</Dropdown.Item>
                      : null
                  )
                  }
                </DropdownButton>
                : null}
              <DropdownButton as={ButtonGroup} size="sm" title={getLocalizedText('navigation', 'race')}
                variant={'outline-secondary'} onSelect={(action, e) => handleAction(action)}>
                {['inscription', 'race', 'nc', 'calendar', 'raceEditor'].map(action =>
                  showButton(action) ?
                    <Dropdown.Item key={action} eventKey={action}>{getLocalizedText('navigation', action)}</Dropdown.Item>
                    : null
                )
                }
              </DropdownButton>
              <DropdownButton as={ButtonGroup} size="sm" title={getLocalizedText('navigation', 'info')}
                variant={'outline-secondary'} onSelect={(action, e) => handleAction(action)}>
                {['calendar', 'statistics', 'chat', 'manual', 'forum'].map(action =>
                  showButton(action) ?
                    <Dropdown.Item key={action} eventKey={action}>{getLocalizedText('navigation', action)}</Dropdown.Item>
                    : null
                )
                }
              </DropdownButton>
            </>
            : null}
          {navigationType === 's' ?
            <DropdownButton as={ButtonGroup} size="sm" title={'Menu'}
              variant={'secondary'} onSelect={(action, e) => handleAction(action)}>
              {['start', 'home', 'team', 'inscription', 'race', 'nc', 'transfermarket',
                'training', 'finance', 'calendar', 'statistics',
                'chat', 'manual', 'forum', 'profile',
                'fairplay', 'nationsCommittee', 'raceEditor', 'admin', 'messages', 'messagesUnread', 'exitAdmin', 'exitSitter', 'signup', 'login', 'logout'].map(action =>
                  showButton(action) ?
                    <Dropdown.Item key={action} eventKey={action}>{getLocalizedText('navigation', action)}</Dropdown.Item>
                    : null
                )
              }
            </DropdownButton>
            : null}

          <DropdownButton as={ButtonGroup} size="sm" variant={'outline-secondary'} onSelect={(newLanguage, e) => setLanguage(newLanguage)}
            title={<>
              {getUnicodeOrImageFlagForLanguage(countries, language, browserInfo)}
              &nbsp;
              {language}
            </>} >
            {
              countries
                .filter(c => 'language' in c)
                .sort(function (a, b) { return a.language.localeCompare(b.language) })
                .map(c =>
                  <Dropdown.Item key={c.language} eventKey={c.language}>
                    {getUnicodeOrImageFlagForLanguage(countries, c.language, browserInfo)}&nbsp;{c.language}
                  </Dropdown.Item>
                )
            }
          </DropdownButton>
          {/* <C4FInfoButton size="sm" placement={'bottom'} title={'Session Information'} text={
            <>
              User: {userInformation === null ? 'not logged in' : userInformation.userName}<br></br>
              {sessionInformation !== null ?
              <>
              Session created: {formatUnixDate(sessionInformation['x-c4f-session-created'])}<br></br>
              Session refreshed: {formatUnixDate(sessionInformation['x-c4f-session-refreshed'])}<br></br>
              Session expires: {formatUnixDate(sessionInformation['x-c4f-session-expires'])}<br></br>
              </>
              : null }
            </>
          } />           */}
        </ButtonGroup>
      </Row>
    </>
  ) : null;

}


export default Navigation;
